import type { Timestamp } from 'firebase/firestore';
import type { Runner } from './admin';

/** timing 配列からスタートタイムを取得（locationId が最小のエントリ） */
export function getStartTime(runner: Runner): string {
  if (!runner.timing || runner.timing.length === 0) return '';
  const sorted = [...runner.timing].sort((a, b) => Number(a.locationId) - Number(b.locationId));
  return sorted[0].time;
}

/** timing 配列からフィニッシュタイムを取得（locationId が最大のエントリ） */
export function getFinishTime(runner: Runner): string {
  if (!runner.timing || runner.timing.length === 0) return '';
  const sorted = [...runner.timing].sort((a, b) => Number(b.locationId) - Number(a.locationId));
  return sorted[0].time;
}

/** claims のステータス */
export type ClaimStatus =
  | 'ready'
  | 'video-queued'
  | 'video-processing'
  | 'video-done'
  | 'video-failed'
  | 'mint-queued'
  | 'mint-processing'
  | 'mint-pending'
  | 'mint-failed'
  | 'completed'
  | 'permanently-failed';

/** claims ドキュメント */
export interface Claim {
  id: string; // docId = runnerId（${raceAlias}-${bib}）
  uid: string;
  raceId: string;
  raceAlias: string;
  raceName: string;
  raceDate: string;
  bib: string;
  startTime: string;
  time: string;
  netTime: string;
  status: ClaimStatus;
  chain: string;
  contractAddress: string;
  destination: string;
  videoWorkerIndex: number | null;
  mintWorkerIndex: number | null;
  mintWalletAddress: string | null;
  fileName: string | null;
  sourceFileName: string | null;
  txHash: string | null;
  txFee: number | null;
  tokenId: string | null;
  tokenName: string;
  mediaUri: string | null;
  hasIntegrated: boolean;
  mint_context: 'on_site' | 'online';
  videoRetryCount: number;
  mintRetryCount: number;
  lastError: string | null;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  startedAt: Timestamp | null;
  videoCompletedAt: Timestamp | null;
  completedAt: Timestamp | null;
  failedAt: Timestamp | null;
  deletedAt: Timestamp | null;
  randomSeed: number;
}

/** ネットタイム計算 */
export function calcNetTime(startTime: string, finishTime: string): string {
  if (!startTime || !finishTime) return '';

  const parseTime = (time: string): number => {
    const parts = time.split(':').map(Number);
    if (parts.length === 3) {
      return parts[0] * 3600 + parts[1] * 60 + parts[2];
    }
    return 0;
  };

  const startSeconds = parseTime(startTime);
  const finishSeconds = parseTime(finishTime);
  const netSeconds = finishSeconds - startSeconds;

  if (netSeconds < 0) return '';

  const hours = Math.floor(netSeconds / 3600);
  const minutes = Math.floor((netSeconds % 3600) / 60);
  const seconds = netSeconds % 60;

  return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
